module.exports = __webpack_public_path__ + "img/chatbot-1.60dd9bd3.svg";